const _excluded = ["applicationId", "locationId", "children", "overrides"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { payments } from '../../node_modules/@square/web-sdk/dist/payments.es.js';
import ErrorScreen from '../../components/error-screen/error-screen.es.js';
import { useDynamicCallback } from '../../hooks/use-dynamic-callback.es.js';
const FormContext = /*#__PURE__*/React.createContext({
  cardTokenizeResponseReceived: null,
  createPaymentRequest: null,
  payments: null
});
function FormProvider(_ref) {
  let applicationId = _ref.applicationId,
    locationId = _ref.locationId,
    children = _ref.children,
    overrides = _ref.overrides,
    props = _objectWithoutProperties(_ref, _excluded);
  const _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    instance = _React$useState2[0],
    setInstance = _React$useState2[1];
  const _React$useState3 = React.useState(() => {
      var _props$createPaymentR;
      return (_props$createPaymentR = props.createPaymentRequest) === null || _props$createPaymentR === void 0 ? void 0 : _props$createPaymentR.call(props);
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 1),
    createPaymentRequest = _React$useState4[0];
  React.useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    async function loadPayment(signal2) {
      await payments(applicationId, locationId, overrides).then(res => {
        if (res === null) {
          throw new Error("Square Web Payments SDK failed to load");
        }
        if (signal2 !== null && signal2 !== void 0 && signal2.aborted) {
          return;
        }
        setInstance(res);
        return res;
      });
    }
    if (applicationId && locationId) {
      loadPayment(signal);
    }
    return () => {
      abortController.abort();
    };
  }, [applicationId, locationId]);
  const cardTokenizeResponseReceived = async rest => {
    if (rest.errors || !props.createVerificationDetails) {
      await props.cardTokenizeResponseReceived(rest);
      return;
    }
    const verifyBuyerResults = await (instance === null || instance === void 0 ? void 0 : instance.verifyBuyer(String(rest.token), props.createVerificationDetails()));
    await props.cardTokenizeResponseReceived(rest, verifyBuyerResults);
  };
  const cardTokenizeResponseReceivedCallback = useDynamicCallback(cardTokenizeResponseReceived);
  if (!applicationId || !locationId) {
    return /* @__PURE__ */React.createElement(ErrorScreen, null);
  }
  if (!instance) return null;
  const context = {
    cardTokenizeResponseReceived: cardTokenizeResponseReceivedCallback,
    createPaymentRequest,
    payments: instance
  };
  return /* @__PURE__ */React.createElement(FormContext.Provider, {
    value: context
  }, children);
}
const useForm = () => {
  const context = React.useContext(FormContext);
  if (context === void 0) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
};
export { FormContext, FormProvider as default, useForm };